import httpRequest from "../../ajax";
import {
  GET_ALL_SKILLS,
  CREATE_SKILL,
  GET_MY_SKILLS,
  GET_SKILL_BY_ID,
  ERROR,
  CREATE_CATEGORY_SKILL,
} from "../actionTypes";

/**
 * @description get all skills action
 * @function getAllSkillsAction
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const getAllSkillsAction = (dispatch) => {
  return httpRequest("get", "/settings/profile/skills/list/1/5000")
    .then(({ data: { data } }) => {
      console.log("DDData", data);
      const action = { type: GET_ALL_SKILLS, payload: data[0] };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

/**
 * @description create skill action
 * @function createSkillAction
 * @param {object} requestObject - request data
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const createSkillAction = (requestObject, dispatch) => {
  return httpRequest("post", "/settings/profile/skills/create", requestObject)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_SKILL, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const errorMessage = response?.data?.message;
      if (errorMessage && errorMessage.toLowerCase().includes("already exist")) {
        // Skill already exists, treat as success
        return { type: CREATE_SKILL, payload: null };
      }
      return {
        payload: errorMessage,
        type: ERROR,
      };
    });
};

/**
 * @description create category skill action
 * @function createCategorySkillAction
 * @param {object} requestObject - request data
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const createCategorySkillAction = (requestObject, dispatch) => {
  return httpRequest("post", "/settings/profile/skills/create-category", requestObject)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_CATEGORY_SKILL, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const errorMessage = response?.data?.message;
      if (errorMessage && errorMessage.toLowerCase().includes("already exist")) {
        // Skill already exists, treat as success
        return { type: CREATE_CATEGORY_SKILL, payload: null };
      }
      return {
        payload: errorMessage,
        type: ERROR,
      };
    });
};

/**
 * @description create a single skill by title convenience wrapper
 * @function createSingleSkillAction
 * @param {string} title - skill title
 * @param {function} dispatch - dispatch function
 * @returns {Promise<object|null>} - returns the action or null
 */
export const createSingleSkillAction = (title, dispatch) => {
  if (!title || typeof title !== "string") return Promise.resolve(null);
  const payload = { skills: [title] };
  return createCategorySkillAction(payload, dispatch);
};

/**
 * @description create only skills that are missing from the existing list
 * @function createMissingSkillsIfAny
 * @param {string[]} selectedSkills - titles selected in UI
 * @param {Array<{id:string,title:string}>} existingSkills - skills available from server
 * @param {function} dispatch - redux dispatch
 * @returns {Promise<object|null>} - action for created skills or null if none
 */
export const createMissingSkillsIfAny = (selectedSkills, existingSkills, dispatch) => {
  const existingTitles = new Set(
    (existingSkills || []).map((s) => (s?.title || s || "").toString().toLowerCase())
  );
  const toCreate = (selectedSkills || [])
    .filter((t) => typeof t === "string")
    .map((t) => t.trim())
    .filter((t) => t.length > 0 && !existingTitles.has(t.toLowerCase()));

  if (toCreate.length === 0) return Promise.resolve(null);
  const action = createCategorySkillAction({ skills: toCreate }, dispatch);
  return action;
};

/**
 * @description get my skill action
 * @function getMySkillsAction
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const getMySkillsAction = (dispatch) => {
  return httpRequest("get", "/settings/profile/skills")
    .then(({ data: { data } }) => {
      const action = {
        type: GET_MY_SKILLS,
        payload: Array.isArray(data) ? data[0] : data,
      };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

/**
 * @description get skill by ID action
 * @function getSkillByIdAction
 * @param {string} skillId - skill id
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const getSkillByIdAction = (skillId, dispatch) => {
  return httpRequest("get", `/settings/profile/skills/${skillId}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_SKILL_BY_ID, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};
